import { useState } from 'react';

export const useCopyToClipboard = (resetDelay = 2000): { copied: boolean; copy: (text: string) => void } => {
  const [copied, setCopied] = useState(false);

  const copy = (text: string): void => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), resetDelay);
    });
  };

  return { copied, copy };
};
